export default "__VITE_ASSET__DOWa7R1c__"